var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import clsx from 'clsx';
import { CategorySelector } from './CategorySelector';
import { PopularKeywords } from './PopularKeywords';
import { Search } from './Search';
export function FilterSearch(_a) {
    var title = _a.title, onSearch = _a.onSearch, searchProps = _a.searchProps, keywordProps = _a.keywordProps, categoryProps = _a.categoryProps;
    return (_jsxs("div", { className: clsx('faq-filter-search', 'faq-filter-search__container'), children: [title && (_jsx(Typography, { variant: "h2", className: "faq-filter-search__title", children: title })), _jsxs("div", { className: clsx('faq-filter-search__inner'), children: [_jsx(Search, __assign({}, searchProps)), categoryProps && _jsx(CategorySelector, __assign({}, categoryProps)), _jsx(Button, { variant: "contained", color: "secondary", disableElevation: true, className: clsx('faq-filter-search__button', 'faq-filter-search-button'), startIcon: _jsx(SearchIcon, {}), onClick: onSearch, children: "\u691C\u7D22" })] }), keywordProps && _jsx(PopularKeywords, __assign({}, keywordProps))] }));
}
//# sourceMappingURL=FilterSearch.js.map